import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, shareReplay, throwError } from 'rxjs';
import { environment } from '../../../../../../../../environments/environment';
import { SupportContactLookups } from '../models/support-contact-lookups';

@Injectable({
  providedIn: 'root'
})
export class SupportContactLookupsService {
  private http = inject(HttpClient);
  private lookups$: Observable<SupportContactLookups> | null = null;

  // Branch offices, products and functions barely change, so the response is fetched on the
  // first Department dialog open and shared with every later one for the rest of the session
  // (there is no cache-control header server-side — caching is entirely on us).
  getLookups(): Observable<SupportContactLookups> {
    if (!this.lookups$) {
      this.lookups$ = this.http.get<SupportContactLookups>(`${environment.apiUrl}/supportContacts/lookups`).pipe(
        // Drop the cached stream on failure, otherwise shareReplay would hand the same error
        // to every later dialog open and the form could never recover without a page reload.
        catchError((error: unknown) => {
          this.lookups$ = null;
          return throwError(() => error);
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.lookups$;
  }
}
